import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // เลื่อนขึ้นทันทีเพื่อให้ Effect ของ CSS จัดการความสมูทแทน
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}